import React, { PureComponent } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { FACheckUpPDFUrl } from '../../../../../configs/ContactConfig';

class FACheckupFooter extends PureComponent {
  render() {
    return (
      <div className="footer-table-fa-checkup mt-10 mb-10 d-flex justify-content-between flex-row flex-wrap">
        <div className="right d-flex">
          <div className="circle-dot text-nowrap">
            <div className="circle circle-excellent" />
            <Translate value="financialAnalysis.faCheckupFooter.excellent" />
          </div>

          <div className="circle-dot text-nowrap">
            <div className="circle circle-good" />
            <Translate value="financialAnalysis.faCheckupFooter.good" />
          </div>

          <div className="circle-dot text-nowrap">
            <div className="circle circle-neutral" />
            <Translate value="financialAnalysis.faCheckupFooter.neutral" />
          </div>

          <div className="circle-dot text-nowrap">
            <div className="circle circle-be-alert" />
            <Translate value="financialAnalysis.faCheckupFooter.beAlert" />
          </div>

          <div className="circle-dot text-nowrap">
            <div className="circle circle-watch-out" />
            <Translate value="financialAnalysis.faCheckupFooter.watchOut" />
          </div>
        </div>

        <div
          style={{
            fontSize: 10,
            fontWeight: 300,
            fontStyle: 'Italic',
            marginTop: 3,
          }}
          className="text-nowrap"
          dangerouslySetInnerHTML={{
            __html: I18n.t('financialAnalysis.faCheckupFooter.summary', {
              url: FACheckUpPDFUrl,
            }),
          }}
        />
      </div>
    );
  }
}

export default FACheckupFooter;
